import React, { useContext, useEffect, useState } from "react";
import { StudentContext } from "./StudentLayout";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { FileText, Clock, CheckCircle2 } from "lucide-react";

const StudentAssignments = () => {
  const { student } = useContext(StudentContext);
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (!student?.selectedProgramId) { setLoading(false); return; }
      try {
        const q = query(collection(db, "assignments"), where("courseId", "==", student.selectedProgramId));
        const snap = await getDocs(q);
        setAssignments(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetch();
  }, [student]);

  return (
    <div data-testid="student-assignments">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">Assignments</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">My Assignments</h1>
        <p className="mt-1 text-slate-600">View tasks assigned by your instructor.</p>
      </div>

      {loading ? (
        <div className="text-slate-500">Loading...</div>
      ) : assignments.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-xl p-10 text-center" data-testid="no-assignments">
          <FileText className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500">No assignments published yet. Check back soon.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {assignments.map((a) => (
            <div key={a.id} className="bg-white border border-slate-200 rounded-xl p-5 flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                <FileText className="w-5 h-5 text-blue-600" />
              </div>
              <div className="flex-1">
                <div className="font-heading font-semibold text-slate-900">{a.title}</div>
                <div className="text-sm text-slate-600 mt-1">{a.description}</div>
                <div className="mt-3 flex items-center gap-4 text-xs">
                  <span className="flex items-center gap-1 text-slate-500"><Clock className="w-3 h-3" /> Deadline: {a.deadline || "—"}</span>
                  {a.status === "completed" ? (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 font-semibold">
                      <CheckCircle2 className="w-3 h-3" /> Submitted
                    </span>
                  ) : (
                    <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 font-semibold">Pending</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentAssignments;
